/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationService } from '../../common/authentication/service/AuthenticationService';
import { PjInjectProxy } from '../../common/extends_fw/PjInjectProxy';
import { PjBaseController, Alert } from '../../common/extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../common/extends_fw/service/PjServiceResponse';
import { MsgLevel } from '../../framework/controller/MsgLevel';
import { CategoryService } from '../service/CategoryService';
import { CategoryCriteriaJson } from '../json/JsonAll';
import { CategoryJson } from '../json/JsonAll';
import { CategoryListJson } from '../json/JsonAll';
import { SelectItemJson } from '../json/JsonAll';
import { DeleteCategoryListJson } from '../json/JsonAll';
import { SharedService } from '../../common/extends_fw/controller/PjBaseController';

/**
 * カテゴリ画面について出力処理およびイベント処理を行う。
 */
export class CategoryController extends PjBaseController {

    // メインカテゴリID
    public mainId: string;

    // グリッド情報
    public gridOptions: any;

    // 前回検索情報
    public criteria: CategoryCriteriaJson;

    // カテゴリ一覧から削除用JSON
    public deleteList: DeleteCategoryListJson;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $window: ng.IWindowService,
            protected $uibModal: ng.ui.bootstrap.IModalService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected categoryService: CategoryService,
            protected $location: ng.ILocationService,
            protected sharedService: SharedService,
            protected $scope: any) {
        super($stateParams, $translate, $location, pjInjectProxy);

        if (!this.checkAuthenticatedUser()) {
            return;
        }

        this.setTitle('form18.title');
        this.gridOptions = {
            columnDefs: [
                {
                    field: 'mainCategory',
                    displayName: 'item.0083',
                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show([row.entity.mainId,null])">{{row.entity.mainCategory}}</a>' + '<div>',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'subCategory',
                    displayName: 'item.0105',
                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show([row.entity.mainId,row.entity.subId])">{{row.entity.subCategory}}</a>' + '<div>',
                    headerCellFilter: 'translate'
                }
            ],
            enableRowSelection: true,
            enableSelectAll: true,
            enableColumnMenus: false,
            enableHorizontalScrollbar: 0,
            enableColumnResizing: true,
            paginationPageSizes: [10, 25, 100],
            paginationPageSize: 10,
            onRegisterApi: (gridApi: any) : void => {
                this.$scope.gridApi = gridApi;
            },
        };
        this.draw();
        this.$scope.show = (id: string[]) => {
            return this.show_dialog(id);
        };

        //  メインカテゴリリスト取得
        this.getMainList();

        //  sharedService
        let auth: any;

        auth = sharedService.get('auth');
        //  権限が無いユーザはTOPへ戻す
        if (!(auth.role === 3 || auth.role === 4)) {
            this.$location.url('/top');
        }
        //  項目の表示制御(トーマツ)
        $scope.tohmatsu = this.isTohmatsu();
        //  読み取り専用か判定
        $scope.readUser = this.isReadonly();
        $scope.readUserBtn = !this.isReadonly();
    }

    /**
     * ダイアログ表示
     */
    public show_dialog(id: string[] = null): void {
        let test: any = this.$uibModal.open({
            templateUrl: 'template/category/edit.html',
            controller: 'categoryEditController',
            controllerAs: 'categoryEdit',
            resolve: {
                id: function (): string[] {
                    return id;
                }
            },
        }).result.then((result: string) => {
            if (result) {
                this.clearAlert();
                if (result === 'delete') {
                    this.setAlert('message.0027');
                }
                this.reflesh_list(result);
                this.getMainList();
            }
        });
    }

    public reflesh_list(result: string): void {
        this.categoryService.list(this.criteria).then((data: any) => {
            this.$scope.gridApi.selection.clearSelectedRows();
            this.gridOptions.data.splice(0, this.gridOptions.data.length);
            Array.prototype.push.apply(this.gridOptions.data, data.data.categories);
            if (result !== 'delete') {
                this.clearAlert();
                if (data.status === 204) {
                    this.setAlert('message.0004');
                }
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * 検索処理
     */
    public search(): void {
        let criteria: any = {
            mainId: this.$scope.selectedItem || null
        };
        this.criteria = criteria;
        this.reflesh_list('search');
    }

    public delete(): void {
        this.deleteList = null;
        let rows: CategoryJson[] = this.$scope.gridApi.selection.getSelectedRows();
        if (rows.length === 0) {
            alert(this.$translate.instant('MC0000001'));
            return;
        }
        if (!window.confirm(this.$translate.instant('CC0000001'))) {
            return;
        }
        let main: string = this.$scope.gridApi.selection.getSelectedRows().map((x: any) => { return x.subId === null ? x.mainId : null; }).filter(function (x: any, i: any, self: any): any {
            return self.indexOf(x) === i && x !== null && x !== '';
        }).join(',');
        let sub: string = this.$scope.gridApi.selection.getSelectedRows().map((x: any) => { return x.subId; }).filter(function (x: any, i: any, self: any): any {
            return self.indexOf(x) === i && x !== null && x !== '';
        }).join(',');

        this.deleteList = {
            mainIds: main,
            subIds: sub
        };

        this.categoryService.delete(this.deleteList).then((data: any) => {
            this.clearAlert();
            this.setAlert('message.0027');
            this.reflesh_list('delete');
            //  メインカテゴリリスト取得
            this.getMainList();
            let delMainId: any = main.split(',');
            if (delMainId.filter((x: any): boolean => {return x === this.$scope.selectedItem; }).length) {
                this.$scope.selectedItem = null;
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    public getMainList(): void {
        //  メインカテゴリリスト取得
        this.categoryService.getMainCategoryList().then((mainData: any) => {
            this.$scope.mainCategoryList = mainData.data.categories;
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}

export class CategoryEditController extends PjBaseController {

    // モーダル画面タイトル
    public modalTitle: string;

    // 更新ボタン見出し
    public submitCaption: string;

    // 画面情報
    public record: CategoryJson;

    // 表示制御のためメインID退避
    public lastMainId: string;

    // 削除情報
    public deleteInfo: DeleteCategoryListJson = null;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected categoryService: CategoryService,
            protected $location: ng.ILocationService,
            protected $scope: any,
            protected id: number[] = null) {
        super($stateParams, $translate, $location, pjInjectProxy);
        if (id) {
            this.modalTitle = 'form20.title';
            this.submitCaption = 'RC0000004';
            this.categoryService.getRecord(id).then((data: any) => {
                this.record = data.data.category;
                this.lastMainId = this.record.mainId;
            //  メインカテゴリリスト取得
                this.categoryService.getMainCategoryList().then((editMainData: any) => {
                    $scope.mainCategoryList = editMainData.data.categories;
                    //  メインカテゴリ編集時は親カテゴリを表示しないため、一旦nullセット
                    if (id[1] === null) {
                        this.record.mainId = null;
                    }
                }).catch((errorData: any) => {
                    this.catch(errorData);
                });
                $scope.mainEdit = true;
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        } else {
            this.record = {};
            this.modalTitle = 'form19.title';
            this.submitCaption = 'RC0000002';

            //  メインカテゴリリスト取得
            this.categoryService.getMainCategoryList().then((mainData: any) => {
                $scope.mainCategoryList = mainData.data.categories;
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        }
        //  項目の表示制御(トーマツ)
        $scope.tohmatsu = this.isTohmatsu();
        //  読み取り専用か判定
        $scope.readUser = this.isReadonly();
        $scope.readUserBtn = !this.isReadonly();
    }

    public delete(): void {
        if (!window.confirm(this.$translate.instant('CC0000001'))) {
            return;
        }
        let deleteId: any = {
            mainIds: this.id[1] === null ? this.id[0] : null,
            subIds: this.id[1]
        };
        this.deleteInfo = deleteId;
        this.categoryService.delete(this.deleteInfo).then((data: any) => {
            this.$uibModalInstance.close('delete');
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    public update(): void {
        if (this.id === null) {
            if (this.record.mainId === '') {
                this.record.mainId = null;
            }
            this.categoryService.create(this.record).then((data: CategoryJson) => {
                this.$uibModalInstance.close('create');
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        } else {
            let sendData: any = {
                category: this.record.category,
                mainId: this.lastMainId,
                subId: this.record.subId,
                version: this.record.version
            };
            this.categoryService.update(sendData).then((data: CategoryJson) => {
                this.$uibModalInstance.close('update');
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        }
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/controller/CategoryController.ts
 **/